import { Grid, Group, Stack, Text } from '@mantine/core';
import { useMemo } from 'react';

import { Transit, TransitGroup } from '@e-origin/shared';

import { BackButton, TextInput } from '@components';
import { extractStatus } from '../utils';

interface TransitViewHeaderProps {
  transit: Transit;
}

export const TransitViewHeader: React.FC<TransitViewHeaderProps> = ({ transit }) => {
  const status = useMemo(() => extractStatus(transit.generalInfo?.status), [transit.generalInfo?.status]);

  const isArrival = transit.generalInfo?.group === TransitGroup.ARRIVAL;

  return (
    <Stack px="xl" gap="xl" mb="md" mx="xl">
      <BackButton backPath="/transits" data-pw="transit-view-back-button"></BackButton>
      <Group>
        <Stack mr="lg" gap="xs">
          <Text size="xs">Transit name</Text>
          <Text size="xl" fw={700} lh="xs">
            {transit.name}
          </Text>
        </Stack>
        <Stack mr="lg" gap="xs">
          <Text size="xs">Status</Text>
          <Text data-pw="transit-status" size="xl" fw={700} c="blue" lh="xs">
            {status}
          </Text>
        </Stack>
        {!isArrival && <TextInput label="LRN" value={transit.TransitOperation?.LRN} disabled />}
        <TextInput label="MRN" value={transit.TransitOperation?.MRN} disabled />
      </Group>
      <Grid>
        <Grid.Col span={1}>
          <TextInput label="Type" value={transit.TransitOperation?.declarationType} disabled />
        </Grid.Col>
        <Grid.Col span={1}>
          <TextInput label="Security" value={transit.TransitOperation?.security} disabled />
        </Grid.Col>
        {!isArrival && (
          <Grid.Col span={1}>
            <TextInput label="Coverage" value={transit.generalInfo?.totalAmountGuaranteeToBeCovered} disabled />
          </Grid.Col>
        )}
        <Grid.Col span={1}>
          <TextInput label="Packages" value={transit.Consignment?.totalNumberOfPackages} disabled />
        </Grid.Col>
        <Grid.Col span={1}>
          <TextInput label="Total Gross" value={transit.Consignment?.grossMass || ''} disabled />
        </Grid.Col>
        <Grid.Col span={1}>
          <TextInput label="Seals" value={transit.Consignment?.totalNumberOfSeals || ''} disabled />
        </Grid.Col>
        <Grid.Col span={1}>
          <TextInput label="Reduced" value={transit.TransitOperation?.reducedDatasetIndicator} disabled />
        </Grid.Col>

        {!isArrival && (
          <Grid.Col span={2}>
            <TextInput label="Destination declared" value={transit.CustomsOfficeOfDestinationDeclared?.referenceNumber || ''} disabled />{' '}
          </Grid.Col>
        )}

        {isArrival && (
          <Grid.Col span={2}>
            <TextInput label="Destination actual" value={transit.CustomsOfficeOfDestinationActual?.referenceNumber || ''} disabled />{' '}
          </Grid.Col>
        )}

        <Grid.Col span={1.5}>
          <TextInput label="Simplified" value={transit.TransitOperation?.simplifiedProcedure} disabled />
        </Grid.Col>
      </Grid>
    </Stack>
  );
};
